export default __webpack_public_path__ + "static/media/person.7aaf3bd8.svg";